<template>
  <div>
   <header>
          <div class="headerOne">
              <img src="../../assets/images/returnOne.png" @click="$router.go(-1)">
              <span class="buss">{{msg}}</span>
          </div>
      </header>
      <div class="payment">支付好友共享此卡优惠</div>
       <div class="share">
         <div>
             <span>好友名称</span>
             <input type="text" v-model="twoActive">
          </div> 
           <div>
             <span>好友手机号</span>
             <input type="text" :value="oneActive">
          </div> 
      </div>
        <div class="inviteOne" @click="test">邀 请</div>
        <div class="people">共享此卡好友</div>
        <div class="noneOne">
            <ul>
               <li>暂无其他好友共用此会员卡</li>
            </ul>
         </div>
  </div>
</template>
<script>
import axios from 'axios'
axios.defaults.baseURL='/api'
    export default{
        data(){
            return{
                msg:"屈臣氏",
                twoActive:this.$route.query.oneName,
                oneActive:this.$route.query.onePhone,
            }
        },
        methods:{
            test(){          
            }
        }
    }
</script>
<style scoped>
header{
    height:1rem;
    width: 100%;
    border-bottom: 1px solid rgba(0,0,0,0.20);
    position: relative;
}
 .headerOne{
     font-size: 0;  
     }
 .headerOne img{
    display: inline-block;
    margin-top: 0.3rem
 }
  .headerOne img:nth-child(1){
      margin-left: 0.2rem
  }
  .headerOne .buss{
      display: inline-block;
      font-size: 0.35rem;
        position:absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
  }
   .share{
       font-size: 0.35rem
   }
     .share div:nth-child(1),.share div:nth-child(2){
         text-align: center;
         margin: 0.15rem
     }
    .share input{
        border: none;
        outline: none;
        font-size: 0.33rem;
        border-bottom: 1px solid rgba(0,0,0,0.20);
    display: inline-block;
    height: 1rem;
      text-indent: 0.3rem
    }
     .share div:nth-child(1) span{
        margin-right: 0.3rem
    }
    /* .share div:nth-child(2) span{
        margin-right: 0.3rem
    } */
    /* .share div:nth-child(1){
        position: relative;
    } */
     .share div:nth-child(1) input{
        /* position: absolute; */
      text-indent: 0.5rem;
    }
    .inviteOne{
        width: 4rem;
        height: 0.8rem;
       background-image: linear-gradient(to right, #2EA4B0, #06789D);
       color: white;
       font-size: 0.35rem;
       text-align: center;
       line-height: 0.8rem;
        border-radius: 12px;
        margin: 0 auto;
        margin-top: 0.4rem
    }
    .people{
        font-size: 0.35rem;
        color: #333333;
        margin: 0.4rem 0 0.1rem 0.6rem
    }
    .noneOne{
        font-size: 0.3rem;
        color: rgba(0,0,0,0.20);
         margin: 0.2rem 0 0.1rem 0.58rem
    }
    .payment{
       font-size: 0.35rem;
       font-weight: bold;
       text-align: center;
       margin-top:0.6rem
   }
</style>



// WEBPACK FOOTER //
// src/components/sureInvite/sureInvite.vue